export default {"src":"/_next/static/media/grid-horizontal.e8f8c28e.svg","height":1482,"width":1717,"blurWidth":0,"blurHeight":0};